// import { gql } from "@apollo/client";
import { onCreate } from "./onCreate";

const createNoteMutation = /* GraphQL */ `
  mutation CreateNote(
    $input: CreateNoteInput!
    $condition: ModelNoteConditionInput
  ) {
    createNote(input: $input, condition: $condition) {
      id
      type
      itemID
      message
      createdBy
      groupToRead
      groupToEdit
      groupToDelete
      createdAt
      updatedAt
    }
  }
`;

export default async function createNote({ input, client }) {
  const NoteFragment = /* GraphQL */ `
    fragment NewNote on Note {
      id
    }
  `;
  await onCreate({
    input,
    mutation: createNoteMutation,
    fragment: NoteFragment,
    updateCacheFields: null,
    client,
    // refetchQueries: "GetOffer",
  });
}
